module.exports = __webpack_public_path__ + "static-v-shop/1765575532973/img/ic-ingredientes.859c890a.png";